import { HttpClient } from "../HttpClient";

export const PutUpdateWithdrawal = async (id, payload) => {
  try {
    const { data } = await HttpClient.put(`api/withdrawal/${id}`, payload);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
